  // import { 
  //   collection, 
  //   addDoc, 
  //   updateDoc, 
  //   deleteDoc, 
  //   doc, 
  //   getDocs, 
  //   getDoc, 
  //   query, 
  //   where, 
  //   orderBy, 
  //   Timestamp, 
  //   serverTimestamp 
  // } from 'firebase/firestore';
  // import { db } from './firebaseConfig';

  // /**
  //  * Service for handling Firestore operations related to user activities
  //  * This includes tracking user interactions with products across the site
  //  */
  // export const FirestoreService = {
  //   /**
  //    * Track when a user adds an item to their wishlist
  //    * @param {Object} product - The product being added to wishlist
  //    * @param {string} userId - The ID of the current user
  //    * @returns {Promise} - Promise resolving to the document reference
  //    */
  //   trackWishlistAdd: async (product, userId) => {
  //     try {
  //       if (!userId) return null;
        
  //       // First check if this item is already in the user's wishlist
  //       const wishlistQuery = query(
  //         collection(db, 'userWishlists'),
  //         where('userId', '==', userId),
  //         where('productId', '==', product.id)
  //       );
        
  //       const querySnapshot = await getDocs(wishlistQuery);
        
  //       // If item already exists, just update the timestamp
  //       if (!querySnapshot.empty) {
  //         const docRef = doc(db, 'userWishlists', querySnapshot.docs[0].id);
  //         await updateDoc(docRef, {
  //           updatedAt: serverTimestamp()
  //         });
  //         return docRef;
  //       }
        
  //       // Otherwise, add a new document
  //       const wishlistRef = await addDoc(collection(db, 'userWishlists'), {
  //         userId,
  //         productId: product.id,
  //         productName: product.name,
  //         price: product.price || 0,
  //         imageUrl: product.imageUrl || product.image,
  //         createdAt: serverTimestamp(),
  //         updatedAt: serverTimestamp()
  //       });
        
  //       return wishlistRef;
  //     } catch (error) {
  //       console.error('Error tracking wishlist add:', error);
  //       return null;
  //     }
  //   },
    
  //   /**
  //    * Track when a user removes an item from their wishlist
  //    * @param {string} productId - The ID of the product being removed
  //    * @param {string} userId - The ID of the current user
  //    * @returns {Promise} - Promise resolving when the operation is complete
  //    */
  //   trackWishlistRemove: async (productId, userId) => {
  //     try {
  //       if (!userId) return;
        
  //       const wishlistQuery = query(
  //         collection(db, 'userWishlists'),
  //         where('userId', '==', userId),
  //         where('productId', '==', productId)
  //       );
        
  //       const querySnapshot = await getDocs(wishlistQuery);
        
  //       if (!querySnapshot.empty) {
  //         // Delete the document if it exists
  //         const docRef = doc(db, 'userWishlists', querySnapshot.docs[0].id);
  //         await deleteDoc(docRef);
  //       }
  //     } catch (error) {
  //       console.error('Error tracking wishlist removal:', error);
  //     }
  //   },
    
  //   /**
  //    * Track when a user adds an item to their compare list
  //    * @param {Object} product - The product being added to compare
  //    * @param {string} userId - The ID of the current user
  //    * @returns {Promise} - Promise resolving to the document reference
  //    */
  //   trackCompareAdd: async (product, userId) => {
  //     try {
  //       if (!userId) return null;
        
  //       // First check if this item is already in the user's compare list
  //       const compareQuery = query(
  //         collection(db, 'userCompares'),
  //         where('userId', '==', userId),
  //         where('productId', '==', product.id)
  //       );
        
  //       const querySnapshot = await getDocs(compareQuery);
        
  //       // If item already exists, just update the timestamp
  //       if (!querySnapshot.empty) {
  //         const docRef = doc(db, 'userCompares', querySnapshot.docs[0].id);
  //         await updateDoc(docRef, {
  //           updatedAt: serverTimestamp()
  //         });
  //         return docRef;
  //       }
        
  //       // Otherwise, add a new document
  //       const compareRef = await addDoc(collection(db, 'userCompares'), {
  //         userId,
  //         productId: product.id,
  //         productName: product.name,
  //         price: product.price || 0,
  //         imageUrl: product.imageUrl || product.image,
  //         createdAt: serverTimestamp(),
  //         updatedAt: serverTimestamp()
  //       });
        
  //       return compareRef;
  //     } catch (error) {
  //       console.error('Error tracking compare add:', error);
  //       return null;
  //     }
  //   },
    
  //   /**
  //    * Track when a user removes an item from their compare list
  //    * @param {string} productId - The ID of the product being removed
  //    * @param {string} userId - The ID of the current user
  //    * @returns {Promise} - Promise resolving when the operation is complete
  //    */
  //   trackCompareRemove: async (productId, userId) => {
  //     try {
  //       if (!userId) return;
        
  //       const compareQuery = query(
  //         collection(db, 'userCompares'),
  //         where('userId', '==', userId),
  //         where('productId', '==', productId)
  //       );
        
  //       const querySnapshot = await getDocs(compareQuery);
        
  //       if (!querySnapshot.empty) {
  //         // Delete the document if it exists
  //         const docRef = doc(db, 'userCompares', querySnapshot.docs[0].id);
  //         await deleteDoc(docRef);
  //       }
  //     } catch (error) {
  //       console.error('Error tracking compare removal:', error);
  //     }
  //   },
    
  //   /**
  //    * Track when a user adds an item to their cart
  //    * @param {Object} product - The product being added to cart
  //    * @param {number} quantity - The quantity being added
  //    * @param {string} userId - The ID of the current user
  //    * @param {string} source - The source of the add to cart action (e.g., 'product', 'wishlist', 'compare')
  //    * @returns {Promise} - Promise resolving to the document reference
  //    */
  //   trackCartAdd: async (product, quantity, userId, source = 'product') => {
  //     try {
  //       if (!userId) return null;
        
  //       // Add cart history entry
  //       const cartHistoryRef = await addDoc(collection(db, 'cartHistory'), {
  //         userId,
  //         productId: product.id,
  //         productName: product.name,
  //         price: product.price || 0,
  //         quantity: quantity || 1,
  //         imageUrl: product.imageUrl || product.image,
  //         source,
  //         addedAt: serverTimestamp()
  //       });
        
  //       return cartHistoryRef;
  //     } catch (error) {
  //       console.error('Error tracking cart add:', error);
  //       return null;
  //     }
  //   },
    
  //   /**
  //    * Get a user's wishlist from Firestore
  //    * @param {string} userId - The ID of the current user
  //    * @returns {Promise<Array>} - Promise resolving to an array of wishlist items
  //    */
  //   getUserWishlist: async (userId) => {
  //     try {
  //       if (!userId) return [];
        
  //       const wishlistQuery = query(
  //         collection(db, 'userWishlists'),
  //         where('userId', '==', userId),
  //         orderBy('createdAt', 'desc')
  //       );
        
  //       const querySnapshot = await getDocs(wishlistQuery);
        
  //       if (querySnapshot.empty) return [];
        
  //       return querySnapshot.docs.map(doc => ({
  //         id: doc.id,
  //         ...doc.data(),
  //         // Convert Firestore timestamps to JS Date objects
  //         createdAt: doc.data().createdAt?.toDate() || new Date(),
  //         updatedAt: doc.data().updatedAt?.toDate() || new Date()
  //       }));
  //     } catch (error) {
  //       console.error('Error getting user wishlist:', error);
  //       return [];
  //     }
  //   },
    
  //   /**
  //    * Get a user's compare list from Firestore
  //    * @param {string} userId - The ID of the current user
  //    * @returns {Promise<Array>} - Promise resolving to an array of compare items
  //    */
  //   getUserCompareList: async (userId) => {
  //     try {
  //       if (!userId) return [];
        
  //       const compareQuery = query(
  //         collection(db, 'userCompares'),
  //         where('userId', '==', userId),
  //         orderBy('createdAt', 'desc')
  //       );
        
  //       const querySnapshot = await getDocs(compareQuery);
        
  //       if (querySnapshot.empty) return [];
        
  //       return querySnapshot.docs.map(doc => ({
  //         id: doc.id,
  //         ...doc.data(),
  //         // Convert Firestore timestamps to JS Date objects
  //         createdAt: doc.data().createdAt?.toDate() || new Date(),
  //         updatedAt: doc.data().updatedAt?.toDate() || new Date()
  //       }));
  //     } catch (error) {
  //       console.error('Error getting user compare list:', error);
  //       return [];
  //     }
  //   },
    
  //   /**
  //    * Sync local storage items with Firestore
  //    * This can be called when a user logs in to make sure their data is up to date
  //    * @param {string} userId - The ID of the current user
  //    */
  //   syncUserData: async (userId) => {
  //     try {
  //       if (!userId) return;
        
  //       // Get local storage items
  //       const wishlistItems = JSON.parse(localStorage.getItem('wishListItems') || '[]');
  //       const compareItems = JSON.parse(localStorage.getItem('compareItems') || '[]');
        
  //       // Get Firestore items
  //       const firestoreWishlist = await FirestoreService.getUserWishlist(userId);
  //       const firestoreCompare = await FirestoreService.getUserCompareList(userId);
        
  //       // Sync wishlist items
  //       const wishlistPromises = wishlistItems.map(item => 
  //         FirestoreService.trackWishlistAdd(item, userId)
  //       );
        
  //       // Sync compare items
  //       const comparePromises = compareItems.map(item =>
  //         FirestoreService.trackCompareAdd(item, userId)
  //       );
        
  //       // Wait for all operations to complete
  //       await Promise.all([...wishlistPromises, ...comparePromises]);
        
  //       console.log('User data synced with Firestore');
  //     } catch (error) {
  //       console.error('Error syncing user data:', error);
  //     }
  //   }
  // };

  // export default FirestoreService;



  import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  getDoc, 
  query, 
  where, 
  orderBy, 
  Timestamp, 
  serverTimestamp,
  limit
} from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * Error handling wrapper for Firestore queries
 * @param {Function} queryFunc - Async function containing the Firestore query
 * @param {Array|Object} fallbackData - Data to return if query fails
 * @param {String} errorMessage - Custom error message for console
 * @returns {Promise<Array|Object>} - Query results or fallback data
 */
const safeFirestoreQuery = async (queryFunc, fallbackData = [], errorMessage = "Error executing Firestore query") => {
  try {
    return await queryFunc();
  } catch (error) {
    console.error(`${errorMessage}:`, error);
    
    // If this is an index error, provide helpful information
    if (error?.code === 'failed-precondition' || error?.message?.includes('requires an index')) {
      console.warn('This query requires an index. Please check your Firebase console to create the necessary indexes.');
      
      // If the error contains a URL to create the index, log it for easy access
      const indexUrlMatch = error.message.match(/https:\/\/console\.firebase\.google\.com\/[^\s]+/);
      if (indexUrlMatch) {
        console.info('Create the index here:', indexUrlMatch[0]);
      }
    }
    
    // Return fallback data to prevent UI from breaking
    return fallbackData;
  }
};

/**
 * Service for handling Firestore operations related to user activities
 * This includes tracking user interactions with products across the site
 */
export const FirestoreService = {
  /**
   * Track when a user adds an item to their wishlist
   * @param {Object} product - The product being added to wishlist
   * @param {string} userId - The ID of the current user
   * @returns {Promise} - Promise resolving to the document reference
   */
  trackWishlistAdd: async (product, userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId || !product) return null;
        
        // First check if this item is already in the user's wishlist
        const wishlistQuery = query(
          collection(db, 'userWishlists'),
          where('userId', '==', userId),
          where('productId', '==', product.id)
        );
        
        const querySnapshot = await getDocs(wishlistQuery);
        
        // If item already exists, just update the timestamp
        if (!querySnapshot.empty) {
          const docRef = doc(db, 'userWishlists', querySnapshot.docs[0].id);
          await updateDoc(docRef, {
            updatedAt: serverTimestamp()
          });
          return docRef;
        }
        
        // Otherwise, add a new document
        const wishlistRef = await addDoc(collection(db, 'userWishlists'), {
          userId,
          productId: product.id,
          productName: product.name,
          price: product.price || 0,
          imageUrl: product.imageUrl || product.image || '',
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
        
        return wishlistRef;
      },
      null,
      'Error tracking wishlist add'
    );
  },
  
  /**
   * Track when a user removes an item from their wishlist
   * @param {string} productId - The ID of the product being removed
   * @param {string} userId - The ID of the current user
   * @returns {Promise} - Promise resolving when the operation is complete
   */
  trackWishlistRemove: async (productId, userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId || !productId) return;
        
        const wishlistQuery = query(
          collection(db, 'userWishlists'),
          where('userId', '==', userId),
          where('productId', '==', productId)
        );
        
        const querySnapshot = await getDocs(wishlistQuery);
        
        if (!querySnapshot.empty) {
          // Delete the document if it exists
          const docRef = doc(db, 'userWishlists', querySnapshot.docs[0].id);
          await deleteDoc(docRef);
          return true;
        }
        return false;
      },
      false,
      'Error tracking wishlist removal'
    );
  },
  
  /**
   * Track when a user adds an item to their compare list
   * @param {Object} product - The product being added to compare
   * @param {string} userId - The ID of the current user
   * @returns {Promise} - Promise resolving to the document reference
   */
  trackCompareAdd: async (product, userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId || !product) return null;
        
        // First check if this item is already in the user's compare list
        const compareQuery = query(
          collection(db, 'userCompares'),
          where('userId', '==', userId),
          where('productId', '==', product.id)
        );
        
        const querySnapshot = await getDocs(compareQuery);
        
        // If item already exists, just update the timestamp
        if (!querySnapshot.empty) {
          const docRef = doc(db, 'userCompares', querySnapshot.docs[0].id);
          await updateDoc(docRef, {
            updatedAt: serverTimestamp()
          });
          return docRef;
        }
        
        // Otherwise, add a new document
        const compareRef = await addDoc(collection(db, 'userCompares'), {
          userId,
          productId: product.id,
          productName: product.name,
          price: product.price || 0,
          imageUrl: product.imageUrl || product.image || '',
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
        
        return compareRef;
      },
      null,
      'Error tracking compare add'
    );
  },
  
  /**
   * Track when a user removes an item from their compare list
   * @param {string} productId - The ID of the product being removed
   * @param {string} userId - The ID of the current user
   * @returns {Promise} - Promise resolving when the operation is complete
   */
  trackCompareRemove: async (productId, userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId || !productId) return;
        
        const compareQuery = query(
          collection(db, 'userCompares'),
          where('userId', '==', userId),
          where('productId', '==', productId)
        );
        
        const querySnapshot = await getDocs(compareQuery);
        
        if (!querySnapshot.empty) {
          // Delete the document if it exists
          const docRef = doc(db, 'userCompares', querySnapshot.docs[0].id);
          await deleteDoc(docRef);
          return true;
        }
        return false;
      },
      false,
      'Error tracking compare removal'
    );
  },
  
  /**
   * Track when a user adds an item to their cart
   * @param {Object} product - The product being added to cart
   * @param {number} quantity - The quantity being added
   * @param {string} userId - The ID of the current user
   * @param {string} source - The source of the add to cart action (e.g., 'product', 'wishlist', 'compare')
   * @returns {Promise} - Promise resolving to the document reference
   */
  trackCartAdd: async (product, quantity, userId, source = 'product') => {
    return safeFirestoreQuery(
      async () => {
        if (!userId || !product) return null;
        
        // Add cart history entry
        const cartHistoryRef = await addDoc(collection(db, 'cartHistory'), {
          userId,
          productId: product.id,
          productName: product.name,
          price: product.price || 0,
          quantity: quantity || 1,
          imageUrl: product.imageUrl || product.image || '',
          source,
          addedAt: serverTimestamp()
        });
        
        return cartHistoryRef;
      },
      null,
      'Error tracking cart add'
    );
  },
  
  /**
   * Get a user's wishlist from Firestore
   * @param {string} userId - The ID of the current user
   * @returns {Promise<Array>} - Promise resolving to an array of wishlist items
   */
  getUserWishlist: async (userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId) return [];
        
        // Create a query with no orderBy to avoid index issues
        let wishlistQuery;
        
        try {
          // First try with orderBy which requires an index
          wishlistQuery = query(
            collection(db, 'userWishlists'),
            where('userId', '==', userId),
            orderBy('createdAt', 'desc')
          );
        } catch (e) {
          // If that fails, fall back to a simpler query
          wishlistQuery = query(
            collection(db, 'userWishlists'),
            where('userId', '==', userId)
          );
        }
        
        const querySnapshot = await getDocs(wishlistQuery);
        
        if (querySnapshot.empty) return [];
        
        return querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          // Convert Firestore timestamps to JS Date objects
          createdAt: doc.data().createdAt?.toDate() || new Date(),
          updatedAt: doc.data().updatedAt?.toDate() || new Date()
        }));
      },
      [],
      'Error getting user wishlist'
    );
  },
  
  /**
   * Get a user's compare list from Firestore
   * @param {string} userId - The ID of the current user
   * @returns {Promise<Array>} - Promise resolving to an array of compare items
   */
  getUserCompareList: async (userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId) return [];
        
        // Create a query with no orderBy to avoid index issues
        let compareQuery;
        
        try {
          // First try with orderBy which requires an index
          compareQuery = query(
            collection(db, 'userCompares'),
            where('userId', '==', userId),
            orderBy('createdAt', 'desc')
          );
        } catch (e) {
          // If that fails, fall back to a simpler query
          compareQuery = query(
            collection(db, 'userCompares'),
            where('userId', '==', userId)
          );
        }
        
        const querySnapshot = await getDocs(compareQuery);
        
        if (querySnapshot.empty) return [];
        
        return querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          // Convert Firestore timestamps to JS Date objects
          createdAt: doc.data().createdAt?.toDate() || new Date(),
          updatedAt: doc.data().updatedAt?.toDate() || new Date()
        }));
      },
      [],
      'Error getting user compare list'
    );
  },
  
  /**
   * Get user's recent orders
   * @param {string} userId - The ID of the current user
   * @param {number} limitCount - Number of orders to retrieve
   * @returns {Promise<Array>} - Promise resolving to an array of orders
   */
  getRecentOrders: async (userId, limitCount = 5) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId) return [];
        
        // Create a query with no orderBy to avoid index issues
        let ordersQuery;
        
        try {
          // First try with orderBy which requires an index
          ordersQuery = query(
            collection(db, 'orders'),
            where('userId', '==', userId),
            orderBy('createdAt', 'desc'),
            limit(limitCount)
          );
        } catch (e) {
          // If that fails, fall back to a simpler query
          ordersQuery = query(
            collection(db, 'orders'),
            where('userId', '==', userId),
            limit(limitCount)
          );
        }
        
        const querySnapshot = await getDocs(ordersQuery);
        
        if (querySnapshot.empty) return [];
        
        return querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          // Convert Firestore timestamps to JS Date objects
          createdAt: doc.data().createdAt?.toDate() || new Date()
        }));
      },
      [],
      'Error fetching recent orders'
    );
  },
  
  /**
   * Sync local storage items with Firestore
   * This can be called when a user logs in to make sure their data is up to date
   * @param {string} userId - The ID of the current user
   */
  syncUserData: async (userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId) return;
        
        // Get local storage items
        const wishlistItems = JSON.parse(localStorage.getItem('wishListItems') || '[]');
        const compareItems = JSON.parse(localStorage.getItem('compareItems') || '[]');
        
        // Filter out invalid items (missing ID or essential properties)
        const validWishlistItems = wishlistItems.filter(item => item && item.id);
        const validCompareItems = compareItems.filter(item => item && item.id);
        
        // Sync in parallel for better performance
        const syncPromises = [];
        
        // Sync wishlist items
        validWishlistItems.forEach(item => {
          syncPromises.push(FirestoreService.trackWishlistAdd(item, userId));
        });
        
        // Sync compare items
        validCompareItems.forEach(item => {
          syncPromises.push(FirestoreService.trackCompareAdd(item, userId));
        });
        
        // Wait for all operations to complete
        await Promise.allSettled(syncPromises);
        
        console.log('User data synced with Firestore');
        return true;
      },
      false,
      'Error syncing user data'
    );
  },
  
  /**
   * Get a user document from Firestore
   * @param {string} userId - The ID of the user
   * @returns {Promise<Object>} - User data or null if not found
   */
  getUserData: async (userId) => {
    return safeFirestoreQuery(
      async () => {
        if (!userId) return null;
        
        const userDocRef = doc(db, 'users', userId);
        const userDocSnap = await getDoc(userDocRef);
        
        if (userDocSnap.exists()) {
          return {
            id: userDocSnap.id,
            ...userDocSnap.data()
          };
        }
        
        return null;
      },
      null,
      'Error fetching user data'
    );
  }
};

export default FirestoreService;